// extracted by mini-css-extract-plugin
export default {"canvas":"Uit12d","hidden":"gdAMqd","visuallyHidden":"ZLAUj7"};